import * as React from 'react';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
// import '../Header/flicker.css';
import itemData from './itemData.js';

export default function Portfolio() {
  return (
    <div className='projectContainer'>
      <h1>Previous Work:</h1>
    <ImageList id="projects">
      {itemData.map((item) => (
        <ImageListItem className="projectContains" key={item.img} >
          <img
            src={`${item.img}?w=248&fit=crop&auto=format`}
            srcSet={`${item.img}?w=248&fit=crop&auto=format&dpr=2 2x`}
            alt={item.title}
            loading="lazy"
          />
         {/* <a target="_blank" href="https://icons8.com/icon/62925/linkedin-circled">LinkedIn Circled</a> icon by <a target="_blank" href="https://icons8.com">Icons8</a> */}

          <ImageListItemBar className='itemTitle'
            subtitle={item.title}
            title={<a href={item.link}>Live Demo</a>}
            position="below"
          />
          
        </ImageListItem>
        
      ))}
    </ImageList>
    </div>
  );
}
